import { render, staticRenderFns } from "./HeroSessionsList.vue?vue&type=template&id=456dc545&scoped=true"
import script from "./HeroSessionsList.vue?vue&type=script&lang=js"
export * from "./HeroSessionsList.vue?vue&type=script&lang=js"
import style0 from "./HeroSessionsList.vue?vue&type=style&index=0&id=456dc545&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456dc545",
  null
  
)

export default component.exports